import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = Environment.apiUrl;
  private userRole = new BehaviorSubject<String>('');
  userRole$: Observable<String> = this.userRole.asObservable();
  private userDetails = new BehaviorSubject<any>(null);
  userDetails$: Observable<any> = this.userRole.asObservable();
  constructor(private http: HttpClient) { }

  register(user: any) { }
  /* ends here */

  nonHCF(credentials: any) {
    return this.http.post(`${this.apiUrl}/api/SystemUser/Authenticate`, credentials)
  }
  phpLogin(credentials: any) {
    return this.http.post(`${this.apiUrl}/api/PHPUser/Authenticate`, credentials)
  }
  login(payload: any) {
     
    return this.http.post(`${this.apiUrl}/api/FacilityMemberProfile/Authenticate` , payload);
  }
  /* ends here */

  logout() {
    localStorage.removeItem('token');
  }
  /* ends here */

  isAuthenticated() {
    let role = localStorage.getItem('role');
    return (role !== null) ? true : false;
  }

  getCsrfToken() {
    return localStorage.getItem('csrf_token');
  }
  getUserId() {
    return localStorage.getItem('userId');
  }
  /* ends here */
  sendDataToUserDetailsObservable(data: any) {
    this.userDetails.next(data);
  }
  sendDataToUserRoleObservable(data: any) {
    this.userRole.next(data);
  }
  /* ends here */

  hasRole(inputRole: any) {
    let role = localStorage.getItem('role');
    if (inputRole == 'NON-DOH' && role == inputRole) {
      return true;
    }
    return false;
  }
}
